import React, { FC } from 'react';
import OWTag from '../../common/OWTag';

const TSLocationsDisplay: FC<any> = ({ locations = [], notSpecified }) => {
	return (
		<div className="flex flex-row flex-wrap items-center gap-2">
			{locations.length > 0 ? (
				locations.map((_) => _.name).map((loc, idx) => <OWTag key={`ts-loc-${idx}`}>{loc}</OWTag>)
			) : (
				<OWTag>{'All Locations'}</OWTag>
			)}
		</div>
	);
};

export default TSLocationsDisplay;
